import hmacSHA256 from 'crypto-js/hmac-sha256'
import Base64 from 'crypto-js/enc-base64'
import CryptoJS from 'crypto-js'

export const crypto = (obj, key) => {
  const hashDigest = hmacSHA256(JSON.stringify(obj), key)
  const hmacDigest = Base64.stringify(hashDigest)
  return hmacDigest
}

export const cryptoSingle = (secret, deviceId) => {
  const hashDigest = hmacSHA256(deviceId, secret)
  const hmacDigest = Base64.stringify(hashDigest)
  return hmacDigest
}

export function decryptAES(ciphertext, url) {
  function deobfuscate(obfuscatedStr) {
      return obfuscatedStr
          .split(' ')
          .map((code) => String.fromCharCode(code - 1))
          .join('')
  }
  const decrypted = CryptoJS.AES.decrypt(ciphertext, CryptoJS.enc.Utf8.parse(deobfuscate(url)), {
      iv: CryptoJS.enc.Utf8.parse(deobfuscate(url).substr(0, 16)),
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
  })
  const decryptedStr = decrypted.toString(CryptoJS.enc.Utf8)
  return decryptedStr
}
